module.exports = "https://r.nearpod.com/assets/media/image/error-icon-6838831ae271026797b9926758f9091d.svg";